import {useMainStore} from "@/store";

const setup = () => {
    const store = useMainStore();
    if (store.characters.length === 0) {
        return {name: 'character-select'};
    }
    if (store.coppa === null) {
        return {name: 'coppa'};
    }
    if (!store.tutorial_completed) {
        return {name: 'tutorial'};
    }
};

export default setup;
